export const practiceKeys = {
  base: ["practice"] as const,
  details: (practiceId: string) => [...practiceKeys.base, practiceId, "detail"] as const,
  list: () => [...practiceKeys.base, "list"] as const,
} as const;
